import { Theme, createStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) =>
  createStyles({
    signinHeading: {
      margin: `${theme.spacing(3)}px 0`,
    },
    signinHeadingHiddenOnMobile: {
      // Hide the heading itself on mobile, but include it in the layout at a fixed
      // height. So we use visibility: hidden; if we used display: none the heading would
      // be taken out of the layout entirely. But it's still useful as a spacer.
      height: theme.spacing(3),
      visibility: 'hidden',

      [theme.breakpoints.up('sm')]: {
        margin: `${theme.spacing(3)}px 0`,
        height: 'auto',
        visibility: 'inherit',
      },
    },
  });

export default styles;
